import './ToolStatisticsRefreshButtonContainer.scss';
import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { ButtonWithLoader } from '../../../../../../design/buttons/ButtonWithLoader';
import { toLocaleDateTimeString } from '../../../../../helpers/date.helpers';
import { useLoader } from '../../../../../helpers/useLoader';
import { IProjectDetailsStatisticsBl } from '../projectDetailsStatistics.bl';

export const ToolStatisticsRefreshButtonContainer = observer((): ReactElement => {
  const projectDetailsStatisticsBl = useInjection(IProjectDetailsStatisticsBl.$);

  const { projectId } = useParams<{ projectId: string }>();
  const { t } = useTranslator();
  const { withLoaderAsync } = useLoader();

  const handleRefresh = async (): Promise<void> => {
    await withLoaderAsync(async () => {
      await projectDetailsStatisticsBl.refreshToolStatistics(projectId);
    }, 'tool-statistics-loading');
  };

  const generatedAt = toLocaleDateTimeString(projectDetailsStatisticsBl.store.toolStatistics.generatedAt);

  return (
    <div className='statistics-refresh-info'>
      <div className='statistics-refresh-info-button'>
        <span>{t('these_statistics_are_automatically_refreshed_once_per_hour')}</span>
        <ButtonWithLoader
          color='primary'
          onClick={handleRefresh}
          loaderKey='tool-statistics-loading'
        >
          {t('refresh_now')}
        </ButtonWithLoader>
      </div>
      <div>
        {t('last_updated_at')}: {generatedAt}
      </div>
    </div>
  );
});
